module.exports = __webpack_public_path__ + "static/media/safari.237a7f3b.svg";